import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { Toast, ToastOptions } from '../../models/toast.model';

const DEFAULT_DURATION = 5000;
const DEFAULT_TYPE = 'info';

@Component({
	selector: 'app-toast',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.css'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [
				style({ transform: 'translateY(-100%)', opacity: 0 }),
				animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 })),
			]),
		]),
	],
})
export class ToastComponent implements OnDestroy {
	toasts: Toast[] = [];
	private timeouts: Map<string, any> = new Map();

	addToast({ message, duration, type }: ToastOptions) {
		if (!duration) {
			duration = DEFAULT_DURATION;
		}
		if (!type) {
			type = DEFAULT_TYPE;
		}
		const toast: Toast = {
			id: crypto.randomUUID(),
			message,
			timestamp: Date.now(),
			type: type,
		};

		this.toasts.push(toast);
		this.toasts.sort((a, b) => b.timestamp - a.timestamp);

		// Set timeout for auto-removal
		const timeout = setTimeout(() => {
			this.removeToast(toast.id);
		}, duration);

		this.timeouts.set(toast.id, timeout);
	}

	removeToast(id: string) {
		const timeoutId = this.timeouts.get(id);
		if (timeoutId) {
			clearTimeout(timeoutId);
			this.timeouts.delete(id);
		}

		this.toasts = this.toasts.filter(toast => toast.id !== id);
	}

	ngOnDestroy() {
		this.timeouts.forEach(timeoutId => clearTimeout(timeoutId));
		this.timeouts.clear();
	}
}
